import React from "react"

import Layout from "../../components/Layout"
import SEO from "../../components/SEO"


const Studio = () => (
  <Layout>
    <SEO title="Studio" keywords={[]}/>
  </Layout>
);

export default Studio